




















































import { mapGetters } from "vuex";
import Localization from "../app-localization/AppLocalization.vue";
import Notification from "../app-notification/AppNotification.vue";
import { constantRoutes } from "../../../../router";
import { logout } from "../../../../utils/logout";
export default {
  components: {
    Localization,
    Notification,
  },
  computed: {
    ...mapGetters(["permissions", "user"]),
    routers() {
      const parentPaths = ["/treatments"];
      const childPaths: any = [
        {
          path: "requests",
          icon: "mdi-file-document-outline",
          navigateUrl: "/treatments/requests",
        },
        {
          path: "monitoring",
          icon: "mdi-chart-line",
          navigateUrl: "/treatments/monitoring",
        },
        {
          path: "shipment",
          icon: "mdi-certificate",
          navigateUrl: "/treatments/shipment",
        },
      ];
      const childMap = new Map(
        childPaths.map((item) => [
          item.path,
          { icon: item.icon, navigateUrl: item.navigateUrl },
        ])
      );
      const filteredRoutes = this.lodash.cloneDeep(
        constantRoutes.filter((item) => parentPaths.includes(item.path))
      );
      filteredRoutes.forEach((route) => {
        if (route.children) {
          route.children = route.children
            .filter((child) => childMap.has(child.path))
            .map((child) => {
              const childMeta = childMap.get(child.path) as {
                icon: string;
                navigateUrl: string;
              };
              if (!childMeta) return child;
              return {
                ...child,
                meta: {
                  ...(child.meta || {}),
                  icon: childMeta.icon,
                },
                navigateUrl: childMeta.navigateUrl,
              };
            });
        }
      });
      const filteredChildren = filteredRoutes
        .flatMap((route) =>
          (route.children || [])
            .filter((child) => childMap.has(child.path))
            .map((child) => ({
              ...child,
            }))
        )
        .filter(
          (childItem) =>
            childItem.meta &&
            !childItem.meta.hidden &&
            this.checkPermission(childItem)
        );
      return filteredChildren;
    },
  },
  methods: {
    navigate(path: string) {
      this.$router.push(path);
    },
    isActive(path: string) {
      return this.$route.path.startsWith(path);
    },
    checkPermission(item) {
      const permissions = [...this.permissions];
      if (
        !item.meta ||
        !item.meta.context ||
        this.lodash.isEmpty(permissions)
      ) {
        return true;
      }
      const filteredPermissions = this.lodash.filter(permissions, (p) =>
        item.meta.context.includes(p.code)
      );
      if (this.lodash.isEmpty(filteredPermissions)) {
        return false;
      }
      return (
        filteredPermissions.filter((val) => val.action.includes("read"))
          .length > 0
      );
    },
    async handleLogout() {
      await logout(this.$store, this.$router);
    },
  },
};
